// @ts-nocheck
export const localeCodes =  [
  "ja",
  "en",
  "zh-cn"
]
export const localeLoaders = {
  ja: [
    {
      key: "locale_ja_46yaml_f1c25c10",
      load: () => import("#nuxt-i18n/f1c25c10" /* webpackChunkName: "locale_ja_46yaml_f1c25c10" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46yaml_93467a6c",
      load: () => import("#nuxt-i18n/93467a6c" /* webpackChunkName: "locale_en_46yaml_93467a6c" */),
      cache: true
    }
  ],
  "zh-cn": [
    {
      key: "locale_zh_45cn_46yaml_aeff07ca",
      load: () => import("#nuxt-i18n/aeff07ca" /* webpackChunkName: "locale_zh_45cn_46yaml_aeff07ca" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/45ad88ff" /* webpackChunkName: "config_i18n_46config_46ts_45ad88ff" */)
]
export const normalizedLocales = [
  {
    code: "ja",
    language: "ja-JP",
    name: "日本語"
  },
  {
    code: "en",
    language: "en-US",
    name: "English"
  },
  {
    code: "zh-cn",
    language: "zh-CN",
    name: "简体中文"
  }
]
/** client **/

/** client-end **/